import { Language } from '@/core';

// Languages the backend actually stores content in.
const BACKEND_LANGUAGES = ['cs', 'de', 'en'] as const;

// Languages the admin UI supports but the backend has no content for, mapped to the
// backend language that should be used instead when looking up item names/descriptions.
const UNSUPPORTED_BACKEND_LANGUAGE_FALLBACKS: Record<string, keyof Language> = {
  sk: 'cs',
};

/**
 * Maps the active UI language to a language the backend actually has content for.
 * e.g. Slovak (`sk`) UI falls back to Czech (`cs`) backend content, since the
 * backend does not have Slovak translations yet.
 */
export const getContentLanguage = (uiLanguage: string): keyof Language => {
  if ((BACKEND_LANGUAGES as readonly string[]).includes(uiLanguage)) {
    return uiLanguage as keyof Language;
  }
  return UNSUPPORTED_BACKEND_LANGUAGE_FALLBACKS[uiLanguage] ?? 'cs';
};
